module.exports = "query GetAllContacts {\n  paginatedContacts {\n    allContacts {\n      ...MinimalContactFragment\n    }\n  }\n}\n"